import { Row } from "@/components/commons/Generics/GenericTable/GenericTableRow";

/**
 * Informations des compteurs
 */
class MetersInformations {
    public Meters: Meter[];

    public constructor(meters: Array<any>) {
        this.Meters = [];
        meters?.forEach(meter => {this.Meters.push(new Meter(meter))});
    }
}

/**
 * Classe compteur
 */
class Meter extends Row {
    
    public RaepceNumber: string;
    public Informations: Information;
    public Services: Service[];
    public Errors: string[];
    public TechnicalData: any;

    public constructor(data: any) {
        super(data.MeterId, data.Informations.MeterName, null);
        
        this.RaepceNumber = data.RaepceNumber;
        this.TechnicalData = data.TechnicalData;
        this.Informations = new Information(data.Informations);
        this.Services = data.Services?.map(service => 
            new Service(service.Name, service.SubscriptionNumber, service.State, service.StartDate, service.EndDate, service.EndReason, service.Direction, service.Type)) ?? new Array<Service>();
        this.Errors = data.Errors ?? new Array<string>();
    }
}

/**
 * Classe information du compteur
 */
class Information{
    
    public PersistentRef: string;
    public MeterName: string;
    public Invariant: string;
    public SupplyPointNumber: string;
    public Address: string;
    public Expendables: string[];

    public constructor(information: any)
    {
        this.PersistentRef = information.PersistentRef;
        this.MeterName = information.MeterName;
        this.Invariant = information.Invariant;
        this.SupplyPointNumber = information.SupplyPointNumber;
        this.Address = information.Address;
        this.Expendables = information.Expendables;
    }
}

/**
 * Classe service
 */
class Service {

    public Name: string;
    public SubscriptionNumber: string;
    public State: SMAServiceStateEnum;
    public StartDate: Date;
    public EndDate: Date;
    public EndReason: string;
    public Direction: DirectionEnum;
    public Type: SMADataTypeEnum;

    public constructor(name: string, subscriptionNumber: string, state: string, startDate: Date, endDate: Date, endReason: string, direction: string, type: string) {
        this.Name = name;
        this.SubscriptionNumber = subscriptionNumber;
        this.State = parseInt(state as string, 10) as SMAServiceStateEnum;
        this.StartDate = startDate;
        this.EndDate = endDate;
        this.EndReason = endReason;
        this.Direction = parseInt(direction as string, 10) as DirectionEnum;
        this.Type = parseInt(type as string, 10) as SMADataTypeEnum;
    }
}

/**
 * Statut du service SMA
 */
enum SMAServiceStateEnum
{
    None = 0,
    ToValidate,
    Refused,
    Activ,
    Revoked,
    ToBeChecked,
    Obsolete
}

/**
 * Direction du service SMA
 */
enum DirectionEnum
{
    INJECTION,
    SOUTIRAGE
}

/**
 * Type de données du service SMA
 */
enum SMADataTypeEnum
{
    Index,
    Cdc,
    PMax
}

export {
    MetersInformations,
    Meter,
    Service,
    Information,
    SMAServiceStateEnum,
    DirectionEnum,
    SMADataTypeEnum
} 